// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=ltr] .board-column[data-v-8fbe749c] {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}[dir=rtl] .board-column[data-v-8fbe749c] {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
